<wm-data-entity-view
  *ngIf="this.entity.dataEntityRef && showEntity"
  [entity]="this.entity.dataEntityRef"
  [form]="form"
></wm-data-entity-view>
